import { PortalRoutes, type User } from "@lyteflo/types";
import { hasGroupRole, hasLytefloRole } from "@lyteflo/utils";

export const getAccountNameFromUser = (user: User | null): string => {
  if (!user) return "";
  if (hasLytefloRole(user)) {
    return "lyteflo";
  }
  if (hasGroupRole(user)) {
    return user.groups?.[0]?.name ?? "";
  }

  return user.dealers?.[0]?.name ?? "";
};

export const navDestinationFromHref = (href: string): string => {
  if (href === PortalRoutes.HOME) return "home";
  if (href === PortalRoutes.BATTERY_REPORTS) return "reports";
  if (href === PortalRoutes.LIVE_SCANS) return "scans";
  if (href === PortalRoutes.HELP) return "help";
  if (href === PortalRoutes.PROFILE) return "profile";
  if (href === PortalRoutes.USERS) return "users";
  if (href === PortalRoutes.DEVICES) return "devices";
  if (href === PortalRoutes.DEALER_CONFIG) return "dealer-config";
  if (href === PortalRoutes.WIFI_CONFIG) return "wifi-config";
  if (href === PortalRoutes.VEHICLE_SUPPORT) return "vehicle-support";
  if (href === PortalRoutes.LYTEFLO) return "lyteflo";
  if (href === PortalRoutes.UNSCANNED_INVENTORY) return "unscanned-inventory";
  return href;
};
